import { render, staticRenderFns } from "./SafatyRequirements.vue?vue&type=template&id=de9238e6&scoped=true&"
import script from "./SafatyRequirements.vue?vue&type=script&lang=js&"
export * from "./SafatyRequirements.vue?vue&type=script&lang=js&"
import style0 from "./SafatyRequirements.vue?vue&type=style&index=0&id=de9238e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9238e6",
  null
  
)

export default component.exports